import { DisplayPrice } from '@wix/wix-ui-premium-purchase';
import classNames from 'classnames';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'wix-style-react';
import { ProductFullPrice } from 'components/ProductFullPrice/ProductFullPrice';
import { taxIncludedTranslationKey } from '../../../../../constants';
import { Country } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import { AdvancedPlansProductModel } from 'models/AdvancedPlansProductModel';
import { Product } from '../../../Product';
import s from './PriceWithDecimal.scss';

export interface PriceWithDecimalProps {
  rootStore: RootStore;
  product: Product | AdvancedPlansProductModel;
  size?: 'small' | 'tiny';
  fontUpgrade?: boolean;
  className?: string;
}

const PriceWithDecimalComp: React.FC<PriceWithDecimalProps> = ({
  rootStore,
  product,
  size,
  fontUpgrade,
  className,
}) => {
  const { t } = useTranslation();
  const {
    appContext: { country, currencyCode, currentPlanDetails },
    pricesIncludeTax,
    currentCycle,
    isChangePlan,
    isJapanesePackagePicker,
  } = rootStore.appStore;
  const cycle = currentPlanDetails?.paymentCycle || currentCycle;
  const fullPrice = isChangePlan
    ? product.getFullPriceByCycle(cycle)
    : product.getYearlyFullPrice();
  const actualPrice = isChangePlan
    ? product.getActualPriceByCycle(cycle)
    : product.getfirstCycleYearlyMonthly() || product.getYearlyActualPrice();
  const isIndia = country === Country.IN;

  return (
    <div className={classNames(s.priceContainer, className)}>
      <DisplayPrice
        price={actualPrice}
        weight='bold'
        theme={size}
        fontUpgrade={fontUpgrade}
        cycle={t('product_price.month')}
        currencyCode={currencyCode}
        hideZeroDecimal={true}
        dataHook='display-price'
        styling={{
          price: classNames(s.price, { [s.japan]: isJapanesePackagePicker }),
          currencySymbol: classNames(s.currencySymbol, {
            [s.japan]: isJapanesePackagePicker,
          }),
          decimalAndCycle: classNames(s.decimalAndCycle, {
            [s.japan]: isJapanesePackagePicker,
          }),
        }}
      />
      <ProductFullPrice yearlyActualPrice={actualPrice} fullPrice={fullPrice} />
      {pricesIncludeTax && (
        <div className={s.gst} data-hook='tax-note'>
          <Text size='tiny'>{t(taxIncludedTranslationKey[country])}</Text>
        </div>
      )}
      {isIndia && (
        <div className={s.gst} data-hook='annually-note'>
          <Text size='tiny'>{t('product.billed_annually')}</Text>
        </div>
      )}
    </div>
  );
};

export const PriceWithDecimal = withInjectedRootStore(PriceWithDecimalComp);
